import * as React from 'react';

import { Col, Popover, Row } from 'antd';
import { PopoverPlacement, Space } from 'farmhub-ui-core';
import { useSelector } from 'react-redux';

import { RootState } from 'app';
import { DotColor, NameText } from 'components';

import { WrapperColors } from './styles';

interface SelectColorProps {
  color: any;
  setColor: (e: any) => void;
}

const SelectColor = ({ color, setColor }: SelectColorProps): JSX.Element => {
  const colorList = useSelector((state: RootState) => state.color.list);
  const [isVisible, setIsVisivle] = React.useState<boolean>(false);

  const content = () => (
    <WrapperColors>
      <NameText>Thay đổi màu nhóm</NameText>
      <Space height={6} />
      <Row gutter={[8, 8]}>
        {colorList.map((item: any) => (
          <Col
            key={item.id}
            span={4}
            onClick={() => {
              setColor(item);
              setIsVisivle(false);
            }}
          >
            <DotColor color={item.code} size="24px" />
          </Col>
        ))}
      </Row>
    </WrapperColors>
  );

  return (
    <Popover
      arrowPointAtCenter
      content={content}
      placement={PopoverPlacement.BottomRight}
      trigger="click"
      visible={isVisible}
      onVisibleChange={() => setIsVisivle(!isVisible)} // TODO: update in core
    >
      <DotColor color={color?.code} size="24px" />
    </Popover>
  );
};

export default SelectColor;
